import React, { useState, useRef, useEffect } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import { LuUpload } from "react-icons/lu";
import L from "leaflet";
import { useAnalysis } from "../../contexts/AnalysisContext";
import Modal from "../Modal/Modal";
import InputModal from "./InputModal";
import YieldReportModal from "./YieldReportModal";
import { PredictedYieldProvider } from "../../contexts/usePredictedYield";
import HardPolygon from "../analytics/HardPolygon";
import { FaTools } from "react-icons/fa";
import { checkPageStatus } from "../../utilityhook/pagecheck"; // ✅ import utility

const pakistanCoordinates = [33.6844, 73.0479];

const YieldPrediction = () => {
  const [mapCenter, setMapCenter] = useState(pakistanCoordinates);
  const [imageSelector, setOpenImgSelecter] = useState(false);
  const [coord, setCoord] = useState([]);
  const [isActive, setIsActive] = useState(true); // ✅ track status

  const { toastMsg, handleCloseToast } = useAnalysis();
  const mapRef = useRef(null);

useEffect(() => {
  const fetchPageStatus = async () => {
    const active = await checkPageStatus("4-yield"); // ✅ wait for backend or localStorage
    setIsActive(active);
  };
  fetchPageStatus();
}, []);

  useEffect(() => {
    if (coord.length > 0 && mapRef.current) {
      const bounds = L.latLngBounds(coord);
      mapRef.current.flyToBounds(bounds);
    }
  }, [coord]);

  const mapbound = (point) => {
    setCoord(point);
  };

  return (
    <>
      <div className="w-full mt-10 lg:w-[97%] max-h-screen overflow-x-hidden pl-[1vw] absolute -right-3">
        <div className="flex md:pl-5 flex-wrap items-center justify-between w-full gap-2"></div>

        {/* Content Section */}
        <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center h-[90vh] w-[95vw]">
          {/* Left Sidebar */}
          <div className="flex gap-5 lg:pl-5 flex-col items-center justify-start lg:gap-0 h-[45vh] lg:h-[93vh] w-full lg:w-[25%]">
            <PredictedYieldProvider>
              <InputModal mapbound={mapbound} />
              <YieldReportModal />
            </PredictedYieldProvider>
          </div>

          {/* Map Container */}
          <div className="h-[60vh] lg:h-[90vh] w-full lg:w-[70vw] overflow-hidden rounded-md shadow-md shadow-black relative">
            <div className="flex h-full w-full">
              <MapContainer
                center={mapCenter}
                zoom={10}
                className="w-full h-full"
                whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
              >
                <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga" />
                <HardPolygon coord={coord} />
              </MapContainer>
            </div>

            <Modal
              message={toastMsg.message}
              onClose={handleCloseToast}
              type={toastMsg.type}
              isShown={toastMsg.isShown}
            />

            <div className={`${imageSelector ? "block" : "hidden"}`}></div>

            {/* 🚧 Under Maintenance Overlay (only shown when inactive) */}
            {!isActive && (
              <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 bg-opacity-90 flex flex-col items-center justify-center text-center z-[9999] backdrop-blur-sm">
                <FaTools className="text-5xl text-green-500 mb-4 animate-bounce" />
                <h1 className="text-3xl md:text-5xl font-semibold text-gray-600 mb-2">
                  Page Under Maintenance
                </h1>
                <p className="text-gray-500 text-lg max-w-md">
                  We’re currently updating this feature to improve your
                  experience. Please check back soon!
                </p>
                <div className="mt-6">
                  <div className="w-16 h-16 border-4 border-gray-600 border-t-green-500 rounded-full animate-spin mx-auto"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default YieldPrediction;
